export enum Application {
    BookingEngine = 'BookingEngine',
    Commander = 'Commander',
    DeviceHub = 'DeviceHub',
    GuestPortal = 'GuestPortal',
    Kiosk = 'Kiosk',
    Platform = 'Platform',
}
